<template>
  <v-menu
    key="authorRating"
    @click.native.stop.prevent
    style="display: inline-block;"
    :disabled="disabled"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :small="!showText"
        height="20px"
        text
        @click.stop
        v-on="on"
        :class="{
          'ml-0': true,
          'mr-1': true,
          'pa-0': true,
          'no-events': disabled,
          'author-rating-btn': true
        }"
      >
        <v-layout column>
          <answer-icon :value="value"></answer-icon>
          <answer-text v-if="showText" :value="value"></answer-text>
        </v-layout>
      </v-btn>
    </template>
    <author-answer-card v-model="authorAnswer"> </author-answer-card>
  </v-menu>
</template>

<script>
import AnswerIcon from './AnswerIcon';
import AuthorAnswerCard from './AuthorAnswerCard';
import AnswerText from './AnswerText';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  components: { AnswerIcon, AuthorAnswerCard, AnswerText },
  computed: {
    authorAnswer: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      }
    }
  },
  methods: {
  }
};
</script>

<style>
.no-events {
  pointer-events: none;
}
</style>
